import { mockBuilder } from '../utils/builderHelper.es.js';
import { LibraryStats } from './LibraryStats.es.js';

/** @module Mocks */ /** typedoc */
function aLibraryStats() {
    return mockBuilder(new LibraryStats())
        .withSharesCount(10)
        .withCommentsCount(20)
        .withMastersCount(30)
        .withUploadsCount(40)
        .withOriginalAlbumsCount(2)
        .withMasteredAlbumsCount(1)
        .withReferenceTracksCount(1);
}

export { aLibraryStats };
